import { Attachment, Modal, ModalProps } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { AttachmentPreviewModalBody } from './AttachmentPreviewModalBody'
import { AttachmentPreviewModalContextProvider } from './context/attachmentPreviewModalContext'

interface AttachmentPreviewModalProps extends ModalProps {
  attachment: Attachment
  footerButton?: ReactElement
  isShoeboxReadOnly?: boolean
  onFileSelect?: () => void
  onOpenDuplicate?: (attachmentId: string) => void
  setDescription?: (description: string) => void
}

export const AttachmentPreviewModal = ({
  attachment,
  id: modalId,
  footerButton,
  isShoeboxReadOnly,
  onFileSelect,
  onOpenDuplicate,
}: AttachmentPreviewModalProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <AttachmentPreviewModalContextProvider
      attachment={attachment}
      footerButton={footerButton}
      isShoeboxReadOnly={isShoeboxReadOnly}
      modalId={modalId}
      onFileSelect={onFileSelect}
      onOpenDuplicate={onOpenDuplicate}
      trackingSource="receipts"
    >
      <Modal id={modalId} autofocusOnInput size="xl">
        <Modal.Header title={t('attachment_preview_modal.title')} />
        <Modal.Body>
          <AttachmentPreviewModalBody />
        </Modal.Body>
      </Modal>
    </AttachmentPreviewModalContextProvider>
  )
}
